/** Agent codes are 2-letter section prefix + 3-digit creation order and never change when a card moves. */
export type CodeMap = Record<string, string>;

/** Next free code for a prefix: highest existing number + 1. */
export const nextCode = (prefix: string, ...maps: CodeMap[]): string => {
  const max = maps
    .flatMap((m) => Object.values(m))
    .filter((code) => code.slice(0, 2) === prefix)
    .reduce((acc, code) => Math.max(acc, Number.parseInt(code.slice(2), 10) || 0), 0);
  return prefix + String(max + 1).padStart(3, '0');
};

/** Seeded codes win over runtime-allocated ones; null when the agent has no code. */
export const codeFor = (id: string, seeded: CodeMap, allocated: CodeMap): string | null =>
  seeded[id] ?? allocated[id] ?? null;
